const guiColors = {
    'motion-primary': 'hsla(325, 60%, 60%, 1)',
    'motion-primary-transparent': 'hsla(325, 60%, 60%, 0.9)',
    'motion-tertiary': 'hsla(325, 42%, 51%, 1)',

    'looks-secondary': 'hsla(325, 60%, 60%, 1)',
    'looks-tertiary': 'hsla(325, 42%, 51%, 1)',
    'looks-transparent': 'hsla(325, 60%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(325, 60%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(325, 42%, 51%, 1)',

    'extensions-primary': 'hsla(325, 60%, 60%, 1)',
    'extensions-tertiary': 'hsla(325, 42%, 51%, 1)',
    'extensions-transparent': 'hsla(325, 60%, 60%, 0.35)',
    'extensions-light': 'hsla(325, 42%, 51%, 1)',

    'drop-highlight': 'hsla(325, 60%, 70%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
